import React from 'react';
import '../../styles/shimmer.css'; // Import your CSS file for shimmer effect

const ShimmerLoader = ({ width = '200px', height = '16px' }) => {
  return (
    <div
      className="shimmer-line"
      style={{ width, height }}
    ></div>
  );
};

export default ShimmerLoader;